import React from 'react'

import './notFound.scss'

import notFound from '../../assets/svg/404.svg'

import { useNavigate } from 'react-router-dom'

export default function index() {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const history = useNavigate()

  const pageHandler = () => {
    history('/')
  }

  return (
    <div id='notFound'>
      <img src={notFound} alt='notFound' width={400} />
      <button onClick={pageHandler}>صفحه اصلی</button>
    </div>
  )
}
